import PyramidStats from './PyramidStats';

export default PyramidStats;
